import { Selector } from "misc/selectors";
import { useApps } from "misc/api/keycloakApi";
import { useTranslation } from "react-i18next"; // Add this import

const AppSelector = props => {
    const { apps } = useApps();
    const { t } = useTranslation(); // Add this line

    return <Selector options={apps.map(app => ({ value: app, label: t(`t_app_${app}`) }))} {...props} />;
};

export default AppSelector;
